export default {
    computed: {
        postInfo() {
            return this.post;
        },
        userInfo() {
            const creator = this.postInfo && this.postInfo.creator;
            return creator
                ? Object.assign({}, creator, {
                    fullName: creator.fullName ?? creator.userName,
                })
                : null;
        },
        comments() {
            return (this.postInfo && this.postInfo.comments) || [];
        },
        contentUrls() {
            return (this.postInfo
                && this.postInfo.contentUrls
                && this.postInfo.contentUrls.map(content => ({
                    type: content.type,
                    url: content.urls[0],
                }))) || [];
        },
        formattedDescription() {
            let description = (this.postInfo && this.postInfo.description) || '';
            // Replace hashtags with HTML tags
            description = description.replace(
                /#(\w+)/g,
                `<a class="hashtag" href="/social/hashtag/$1">#$1</a>`
            );
            this.$nextTick(() => {
                const hashtags = this.$el.querySelectorAll('a.hashtag');
                hashtags.forEach(hashtag => {
                    hashtag.addEventListener('click', this.interceptHashtagNavigation)
                })
            });
            return description;
        }
    },
    methods: {
        interceptHashtagNavigation(event) {
            const hashtag = event.target.innerText.substring(1);
            this.$router.push(`/social/hashtag/${hashtag}`);
            event.preventDefault();
        }
    }
}